// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"158":"labels","496":"campaigns","644":"account","721":"inbox","806":"user"}[chunkId] + "." + {"158":"5f5fab6afc665e0b506a","496":"d1989d160c213ba11a8a","644":"f2ba2f4b5fc171dbbd9e","721":"7eb86f2a022ce81f7f7a","806":"d514a4c47338d404480d"}[chunkId] + ".js";
};